export default __webpack_public_path__ + "static/media/NotoSerif.94445639.woff";